
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { ControladorDeNotificaciones, Notificacion } from '@/components/a-interfaz/a-notificaciones/a-notificaciones';
    import jQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { create } from 'domain';
import { Guid } from 'guid-typescript';


    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public ControladorPrincipal: ControladorBase;
        public get Controlador() { return Vue.observable( Utiles.ControladorDeNotificaciones ); }
        public get Notificaciones() { return this.Controlador.Notificaciones; }
        public get Usuario() { return this.ControladorPrincipal.Usuario; };

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            for ( let not of this.Notificaciones )
            {
                if ( not.Montada )
                {

                    not.Montada = false;
                }

            }
            this.Eventos.forEach( x => x() );
            console.log( 'on destroy' );
        }

        created()
        {
            this.Eventos.push(
                this.Controlador.onNotificacion.subscribe( x =>
                {
                    if ( this.Abierto )
                    {
                        this.Agregar( x );

                    }

                } ) );
        }

        public async Agregar( notificacion: Notificacion )
        {
            if ( notificacion.Eliminada || !this.Abierto || !document.getElementById( 'x-notificaciones-contenedor' ) )
                return;

            let divId = Guid.create().toString();
            jQuery( '<div/>', {
                id: 'x-notificacion-' + notificacion.Id + divId
            } ).appendTo( '#x-notificaciones-contenedor' );
            notificacion.CrearInstancia();
            notificacion.DivID = 'x-notificacion-' + notificacion.Id + divId;

            await new Promise( async ( resolve, reject ) =>
            {
                while ( !document.getElementById( 'x-notificacion-' + notificacion.Id + divId ) )
                {
                    console.log('test' );
                    await Wait( 100 );
                }
                resolve();
            } )

            console.log( document.getElementById( notificacion.DivID ) );
            notificacion.Instancia.$mount( document.getElementById( notificacion.DivID ) );
            notificacion.Montada = true;
        }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        async onAbierto()
        {
            if ( this.Abierto )
            {
                this.$nextTick( () =>
                {
                    for ( let notificacion of this.Notificaciones )
                    {
                        if ( !notificacion.Montada  )
                        {
                            this.Agregar( notificacion );
                        }
                    }
                })

            }
        }
    }
